import { Injectable } from "@nestjs/common";
import { EntityRepository, Repository } from "typeorm";
import { VisitorEntry } from "../entity/security.entity";


@Injectable()
@EntityRepository(VisitorEntry)
export class VisitorRepo extends Repository<VisitorEntry>{
    
}